function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48 0H16C7.16344 0 0 7.16344 0 16V48C0 56.8366 7.16344 64 16 64H48C56.8366 64 64 56.8366 64 48V16C64 7.16344 56.8366 0 48 0Z",
  fill: "#0F0F10"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.8336 36.8011C48.8336 46.5496 40.9314 54.4504 31.1844 54.4504C25.4884 54.4504 20.4239 51.7521 17.196 47.5645C18.8768 48.3531 20.7548 48.7943 22.7348 48.7943C23.944 48.7943 25.1161 48.6303 26.2274 48.3215C31.5346 46.8529 35.485 42.1167 35.7759 36.4124C35.787 36.1891 35.7925 35.9643 35.7925 35.7381C35.7925 33.4424 35.1996 31.2858 34.1599 29.4119C34.0772 29.263 33.9931 29.1156 33.9048 28.9707C33.9035 28.9693 33.9021 28.9679 33.9021 28.9667L33.578 28.4053C32.9989 27.4002 33.3423 26.1151 34.3474 25.5346L37.3795 23.785C38.3847 23.2045 38.7294 21.9193 38.1489 20.9141L36.748 18.4887C36.555 18.1538 36.1262 18.0393 35.7911 18.2322L26.9072 23.3615L21.8427 26.2861C21.8386 26.289 21.833 26.2916 21.8289 26.2945C21.5049 26.4915 21.3959 26.9121 21.5862 27.2416L22.9871 29.6685C23.5676 30.6737 24.8527 31.017 25.8565 30.4379L28.89 28.6866C29.629 28.2593 30.5211 28.3338 31.172 28.8054C31.5263 29.2009 31.8448 29.6298 32.1234 30.0863C32.1261 30.0918 32.1303 30.0972 32.1344 30.1042L32.3412 30.464C32.3426 30.4669 32.3454 30.4695 32.3467 30.4736C33.0251 31.7229 33.4112 33.1569 33.4112 34.6791C33.4112 39.5533 29.4608 43.5037 24.5866 43.5037C20.5562 43.5037 17.1546 40.8013 16.1012 37.1074C16.0943 37.0866 16.0888 37.0659 16.0833 37.044C16.0653 36.9776 16.0474 36.9101 16.0295 36.8426C16.0281 36.8356 16.0253 36.8287 16.024 36.8206C15.682 35.4843 15.5 34.0834 15.5 32.6398C15.5 29.2659 16.4941 26.1221 18.2067 23.4884C18.197 23.4898 18.1887 23.4939 18.1805 23.4982C23.4091 15.4635 31.1844 9.5 31.1844 9.5C31.1844 9.5 35.2506 12.6398 39.4781 17.4173C43.8794 22.3882 48.4558 29.1306 48.8102 35.9559C48.8267 36.2372 48.8336 36.5199 48.8336 36.8011Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.81 35.9566C48.7479 34.7515 48.5535 33.5492 48.2529 32.3592C47.5263 29.4968 46.1805 26.7018 44.5507 24.1055C44.6528 24.9659 44.7051 25.8428 44.7051 26.7308C44.7051 38.7143 35.1484 48.4669 23.242 48.7839C23.2324 48.7839 23.2227 48.7854 23.2131 48.7854C23.0545 48.7923 22.8946 48.7949 22.7346 48.7949C22.6574 48.7949 22.5802 48.7949 22.5044 48.7923C20.6236 48.7605 18.8408 48.3304 17.2358 47.5831C17.222 47.5774 17.2096 47.572 17.1958 47.565C17.3751 47.7968 17.5598 48.0255 17.7501 48.2477C20.9876 52.0436 25.8039 54.4511 31.1842 54.4511C40.9312 54.4511 48.8334 46.5503 48.8334 36.8019C48.8334 36.5206 48.8265 36.2379 48.81 35.9566Z",
  fill: "black"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.81 35.9566C48.7479 34.7515 48.5535 33.5492 48.2529 32.3592C47.5263 29.4968 46.1805 26.7018 44.5507 24.1055C44.6528 24.9659 44.7051 25.8428 44.7051 26.7308C44.7051 38.7143 35.1484 48.4669 23.242 48.7839C23.2324 48.7839 23.2227 48.7854 23.2131 48.7854C23.0545 48.7923 22.8946 48.7949 22.7346 48.7949C22.6574 48.7949 22.5802 48.7949 22.5044 48.7923C20.6236 48.7605 18.8408 48.3304 17.2358 47.5831C17.222 47.5774 17.2096 47.572 17.1958 47.565C17.3751 47.7968 17.5598 48.0255 17.7501 48.2477C20.9876 52.0436 25.8039 54.4511 31.1842 54.4511C40.9312 54.4511 48.8334 46.5503 48.8334 36.8019C48.8334 36.5206 48.8265 36.2379 48.81 35.9566Z",
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.8334 36.802C48.8334 46.5505 40.9312 54.4512 31.1842 54.4512C25.8039 54.4512 20.9876 52.0438 17.7501 48.2478C17.5598 48.0257 17.3751 47.7969 17.1958 47.5653C17.2096 47.5722 17.222 47.5776 17.2358 47.5832C17.677 47.8797 18.1307 48.1596 18.5953 48.4217C21.4813 50.0444 24.8098 50.9697 28.3562 50.9697C38.9209 50.9697 47.5676 42.7504 48.2529 32.3594C48.5535 33.5493 48.7479 34.7517 48.81 35.9568C48.8265 36.2381 48.8334 36.5207 48.8334 36.802Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 12.9458,
  y: 20.3555,
  width: 39.1376,
  height: 37.8456,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.875
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.118348 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 30.5392,
  y1: 18.4891,
  x2: 42.4616,
  y2: 48.3159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B9B8C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 43.0455,
  y1: 39.2783,
  x2: 33.5512,
  y2: 52.763,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E3E3E8"
})));

var SvgHitpawWatermarkRemoverLogo = function SvgHitpawWatermarkRemoverLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHitpawWatermarkRemoverLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hitpaw-watermark-remover-logo.a58e6312.svg";
export { ForwardRef as ReactComponent };